var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Scaffold',[_c('HeroHeader',{attrs:{"title":"Von dir erstellte Touren","buttons":_vm.buttons}}),_c('TourList',{attrs:{"tours":_vm.userTours}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }